<template>
  <el-image
    v-if="src !== ''"
    :fit="fit"
    :preview-src-list="realSrcList"
    :src="`${realSrc}`"
    :style="`width:${realWidth};height:${realHeight};`"
  >
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
  <el-image v-else :src="loadingImage">

  </el-image>
</template>

<script>
import {isExternal} from "@/utils/validate";
import loadingImage from "@/assets/img/loading.gif";

export default {
  name: "ImagePreview",
  props: {
    src: {
      type: String,
      default: ""
    },
    fit: {
      type: String,
      default: ""
    },
    width: {
      type: [Number, String],
      default: ""
    },
    height: {
      type: [Number, String],
      default: ""
    }
  },
  computed: {
    loadingImage() {
      return loadingImage;
    },
    realSrc() {
      if (!this.src) {
        return;
      }
      let real_src = this.src.split(",")[0];
      if (isExternal(real_src)) {
        return real_src;
      }
      return process.env.VUE_APP_BASE_API + real_src;
    },
    realSrcList() {
      if (!this.src) {
        return;
      }
      let real_src_list = this.src.split(",");
      let srcList = [];
      real_src_list.forEach(item => {
        if (isExternal(item)) {
          return srcList.push(item);
        }
        return srcList.push(process.env.VUE_APP_BASE_API + item);
      });
      return srcList;
    },
    realWidth() {
      return typeof this.width == "string" ? this.width : `${this.width}px`;
    },
    realHeight() {
      return typeof this.height == "string" ? this.height : `${this.height}px`;
    }
  },
};
</script>

<style lang="scss">
.el-image {
  border-radius: 5px;
  box-shadow: 0 0 5px 1px #ccc;

  .el-image__inner {
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 30px;
  }

  .el-image__placeholder {
    background: url('../../assets/img/loading.gif') no-repeat 50% 50%;
    background-size: 50%;
    width: 100%;
    height: 100%;
  }
}

.loader {
  width: 0;
  height: 0;
  text-indent: -9999em;
  margin: 89px auto;
  box-shadow: -0.625em -0.625em 0 0.625em #9b59b6, 0.625em -0.625em 0 0.625em #9b59b6, -0.625em 0.625em 0 0.625em #9b59b6, 0.625em 0.625em 0 0.625em #9b59b6;
  animation: circSquare 1.5s ease-in-out infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/ImagePreview/index.vue